import { render } from "./BlogPosts.vue?vue&type=template&id=4a9598dd&scoped=true"
import script from "./BlogPosts.vue?vue&type=script&lang=js"
export * from "./BlogPosts.vue?vue&type=script&lang=js"

import "./BlogPosts.vue?vue&type=style&index=0&id=4a9598dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9598dd"]])

export default __exports__